import { useEffect, useState } from 'react';

import { useModuleSettingsHook } from '../../../Hooks/Maintenance/ModulesSettings/modulesSettingsHooks';

import { AutoCompleteDropdownInterface } from '../../../Models/Common/FormFieldComponentInterfaces';

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';

import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { ModuleSettingField } from '../../../Utilities/Enums/ParametersEnum';

import AutoCompleteDropdown from '../AutoCompleteDropdown';

export default function ModulesSettingsDropdown(fieldProps: AutoCompleteDropdownInterface) {
	let {
		name,
		title,
		fieldValue,
		options,
		isLoadingDropdown,
		disabled,
		required,
		errorMessages,
		handleOnChange,
        hideLabel,
        fieldClassName,
	} = fieldProps;

	//Use States
    const [queryStr, setQueryStr] = useState({
        pageSize: 2000,
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

	const q_queryKey = [CachingEnum.MODULES_SETTINGS_LIST, queryStr]
    const { data, fetchStatus } = useModuleSettingsHook(q_queryKey, queryStr);
    
    const modulesSettingsProps = {
        name: name,
        title: title,
        fieldValue: fieldValue,
        options: data?.data?.list?.map((item: any) => { return { id: item?.[ModuleSettingField.PUBLIC_ID] ?? "", ...item  }}) ?? [], 
        isLoadingDropdown: fetchStatus == "fetching",
        disabled: disabled,
        required: required,
        hideLabel: hideLabel,
        errorMessages: errorMessages,
        handleOnChange: handleOnChange,
        fieldClassName: fieldClassName,
    };

    //Rendering Functions
    return <AutoCompleteDropdown {...modulesSettingsProps} />
}
